import { SizeGuide } from '@/scripts/theme/size-guide'
import { TsDOM as q} from '@/scripts/core/TsDOM'
q.safeDefineElement(SizeGuide)
